import React from 'react'

function StudyMediaConsent() {
    return (
        <div>
            <p>
                CONSENT TO PHOTOGRAPH, FILM, OR VIDEOTAPE A STUDENT
                I hereby consent to the participation and/or performance of my child/children in school assemblies, cultural programs, class performances, sports/field day events, and other events where photographs, audio, and videos may be recorded.
            </p>
            <p>
                I also grant the right to edit, use, and reuse said media for nonprofit purposes including use in print, on the internet, and all other forms of media. I also hereby release the Cumming Tamil School and its agents and volunteers from all claims, demands, and liabilities whatsoever in connection with the above.
                This consent will remain in effect until I revoke it in writing.
            </p>
        </div>
    )
}

export default StudyMediaConsent